<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Datos Postulante al Examen</h1>
        <div class="barra"></div>
        <section class="contenedor-inscripciones">
          <div class="contenedor_datos_inscripcion_examen">
            <router-link :to="`/mesa-examen-noviembre-2026`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
            <div class="postulante_examen_img">
              <img v-if="datos.persona.imagen_perfil != null" :src="imagenRuta" :alt="`${datos.persona.nombre} ${datos.persona.apellido}`">
              <img v-else src="@/assets/image-not-available.jpg" :alt="`${datos.persona.nombre}`">
            </div>
            <div class="contenedor_examen_boxes">
              <div class="contenedor_datos_examen_box">
                <h2>⚬ Datos Personales</h2>
                <p><b>Nombre:</b> {{ datos.persona.nombre }}</p>
                <p><b>Apellido:</b> {{ datos.persona.apellido }}</p>
                <p><b>Email:</b> {{ datos.persona.email }}</p>
                <p><b>Celular:</b> {{ datos.persona.celular }}</p>
              </div>
              <div class="contenedor_datos_examen_box">
                <h2>⚬ Info Inscripción</h2>
                <p><b>Edad:</b> {{ datos.edad }}</p>
                <p><b>Nombre de tu profesor regular:</b> {{ datos.es_alumno_regular_de.nombre }} {{ datos.es_alumno_regular_de.apellido }}</p>
                <p><b>¿Años de práctica regular de Yoga Iyengar?:</b> {{ datos.years }}</p>
                <p><b>¿Cuántas clases por semana toma?:</b> {{ datos.frecuencia_clases_tomadas }}</p>
                <p><b>Nombre de tu profesor mentor:</b> {{ datos.es_alumno_mentor_de.nombre }} {{ datos.es_alumno_mentor_de.apellido }}</p>
                <p><b>Fecha de inicio/registro en mentoría:</b> {{ datos.mentoria }}</p>
                <p><b>¿Es la primera vez que aplica a este nivel?:</b> {{ datos.reincidencia }}</p>
                <p><b>¿Enseñas actualmente? ¿Cuántas clases por semana?:</b> {{ datos.da_clases }}</p>
                <p><b>¿Tiene alguna lesión o condición?:</b> {{ datos.lesiones }}</p>
                <p><b>Comentarios u observaciones:</b> {{ datos.comentarios }}</p>
              </div>
            </div>
            <router-link :to="`/cargar-resultado-examen/${datos.examenes_inscripcion_id}`" class="boton_editar boton_ver_info ancho_boton" v-if="mostrarBotonCargarExamen">Cargar Examen</router-link>
            <!-- <span v-if="mostrarMensajeExamenCargado" class="boton_mesa_examen boton_mesa_examen_cargado boton_ver_info">Examen cargado</span> -->
            <router-link :to="`/examen-cargado/${datos.examenes_inscripcion_id}`" class="boton_mesa_examen boton_mesa_examen_cargado boton_ver_info ancho_boton" v-if="mostrarMensajeExamenCargado">Examen Cargado</router-link>
            <div class="form_section_editar_socio ancho_form contenedor_subir_boton" v-if="mostrarBotonCartaRecomendacion">
              <label for="imagen" class="boton_subir_file">Subir Carta de Recomendacion</label>
              <input
                type="file"
                accept=".pdf,.PDF"
                id="imagen"
                ref="imagen"
                @change="encodeImage"
              >
            </div>
            <div class="boton_ver_carta_recomendacion" v-if="mostrarCartaRecomendacion">
              <a :href="imagenRutaCarta(`${this.datos.carta_recomendacion}`)" target="_blank">Ver Carta de Recomendacíon</a>
            </div>
            <p v-if="mostrarMensajePesado">PESADO</p>
          </div>
        </section>
      </div>
      <section class="contenedor-login">
      </section>
    </section>
  </div>
</template>
<script>
import store from './../store'
import examenService from '../services/examen'
import { PATH_IMG } from '../constants'
export default {
  name: 'DatosInscripcionExamen',
  components: {
  },
  data: function () {
    return {
      mostrarBorrarPlanilla: false,
      mostrarBotonCartaRecomendacion: false,
      store,
      datos: null,
      mostrarBotonCargarExamen: true,
      mostrarMensajeExamenCargado: false,
      mostrarMensajePesado: false,
      mostrarCartaRecomendacion: false,
      examen: {
        carta_recomendacion: null
      }
    }
  },
  methods: {
    imagenRutaCarta: function (x) {
      // console.log(x)
      return `${PATH_IMG}/examen/${x}`
      // return `${PATH_IMG}/examen/${this.datos.planilla_puntaje}`
    },
    encodeImage () {
      const extensiones = this.$refs.imagen.value.substring(this.$refs.imagen.value.lastIndexOf('.'), this.$refs.imagen.value.lenght)
      if (this.$refs.imagen.getAttribute('accept').split(',').indexOf(extensiones) < 0) {
        console.log('Formato incorrecto')
        this.mostrarMensajeFormatoIncorrecto = true
      } else if (this.$refs.imagen.files[0].size > 1200000) {
        console.log('Pesadaaaaao')
        this.mostrarMensajePesado = true
      } else {
        console.log('rrrrrrrrr')
        // const file = e.target.files[0]
        const file = this.$refs.imagen.files[0]
        this.nombrePlanillaPuntaje = file.name
        console.log(file)
        console.log(file.name)
        // this.examen.carta_recomendacion = URL.createObjectURL(file)
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.examen.carta_recomendacion = reader.result
          console.log('FILE:', reader.result)
          console.log('poner fx para subir directo')
          examenService
            .uploadCartaRecomendacion(this.examen, this.$route.params.id)
            .then(respuesta => {
              this.cargando = false
              if (respuesta.success) {
                console.log('SIIIIII')
                location.reload()
                // this.examen = {
                //   fecha_examen: null,
                //   certificacion_id: null,
                //   planilla_puntaje: null,
                //   carta_devolucion: null
                // }
                // this.errores = {
                //   fecha_examen: null,
                //   certificacion_id: null,
                //   aprobo_id: null
                // }
                // this.$router.push('/examen-cargado/1')
                // this.$router.push('/examen-cargado/' + `${this.examen.examenes_inscripcion_id}`)
              } else {
                // this.errores = {
                //   fecha_examen: null,
                //   certificacion_id: null,
                //   aprobo_id: null,
                //   ...respuesta.errors
                // }
              }
            })
        })
        reader.readAsDataURL(file)
        // this.mostrarBorrarPlanilla = true
      }
    }
  },
  computed: {
    imagenRuta: function () {
      return `${PATH_IMG}/${this.datos.persona.imagen_perfil}`
    }
  },
  mounted: function () {
    examenService
      .traerDatosAnotadosExamen(this.$route.params.id)
      .then(respuesta => {
        // this.cargando = false
        console.log('Datos: ', respuesta)
        this.datos = respuesta
        if (this.datos.carta_recomendacion == null) {
          this.mostrarCartaRecomendacion = false
          this.mostrarBotonCartaRecomendacion = true
        } else {
          this.mostrarCartaRecomendacion = true
          this.mostrarBotonCartaRecomendacion = false
        }
      })
    examenService
      .checkCargaDeExamen(this.$route.params.id)
      .then(respuesta => {
        console.log(respuesta)
        if (respuesta.success) {
          this.mostrarBotonCargarExamen = false
          this.mostrarMensajeExamenCargado = true
        }
      })
  }
}
</script>
<style>

</style>
